import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Form from '../../FormIO/presentation/FormWithValidations';
import { connect } from 'react-redux';
import * as urls from '../../shared/urls';
import './assets/DataEntryForm.scss';

interface IDataEntryFormOwnProps {
  formId: string;
  readOnly?: boolean;
  data?: any;
  injectToSidebar?: any;
  onChange?: (formData: any, isValid?: boolean) => void;
  setFormErrors?: (errors: Array<any>) => void;
}

export interface IDataEntryFormPropsFromState {
  serviceURL: string;
  formIOUrl: string;
}

export interface IDataEntryFormPropsFromActions { }

export type IDataEntryFormProps = IDataEntryFormOwnProps &
  IDataEntryFormPropsFromActions &
  IDataEntryFormPropsFromState;

export class DataEntryForm extends React.Component<IDataEntryFormProps, any> {
  private form: any;

  state = {
    sidebarElement: null,
  };

  logData = () => {
    if (this.form && this.form.getSubmission) {
      console.log(this.form.getSubmission());
    }
  };

  getFormData = () => {
    return this.form && this.form.getSubmission ? this.form.getSubmission() : null;
    };

    private wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    flushPendingInputCommit = async () => {
        const active = document.activeElement as HTMLElement | null;
        if (active && typeof active.blur === 'function') {
            active.blur();
        }
        await this.wait(225);
    };

    getLatestFormData = async () => {
        await this.flushPendingInputCommit();
        return this.getFormData();
    };

    isFormValid = () => {
        return !!this.form && this.form.isValid ? this.form.isValid() : false;
    };

    isFormValidAfterFlush = async () => {
        await this.flushPendingInputCommit();
        return this.isFormValid();
    };

    getValidationErrorsAfterFlush = async () => {
        await this.flushPendingInputCommit();
        return this.form && this.form.getValidationErrors
            ? this.form.getValidationErrors(true)
            : [];
    };

  formLoaded = () => {
    let divToLoad = document.getElementById('divSidebarAppend');
    if (!divToLoad) {
      divToLoad = document.createElement('div');
      divToLoad.id = 'divSidebarAppend';
    }
    const sidebar = document.getElementsByClassName('sidebar--wrapper')[0];
    if (!sidebar || !divToLoad) {
      return;
    }
    sidebar.appendChild(divToLoad);

    if (this.state.sidebarElement !== divToLoad) {
      this.setState({ sidebarElement: divToLoad });
    }
  };

  onChange = (formData: any, valid?: boolean) => {
    if (this.props.onChange) {
      const isValid =
        typeof valid === 'boolean' ? valid : this.isFormValid();
      this.props.onChange(formData, isValid);
    }
  };

  componentDidUpdate(prevProps: IDataEntryFormOwnProps) {
    if (!this.state.sidebarElement) {
      this.formLoaded();
    }

    if (prevProps.data !== this.props.data && this.props.data && this.props.onChange) {
      this.onChange(this.props.data, this.isFormValid());
    }
  }

  onFormRender = () => {
    this.formLoaded();
    // Defer validity check to next tick to ensure form is fully initialized
    if (this.props.onChange && this.form && this.form.getSubmission) {
      setTimeout(() => {
        this.onChange(this.form.getSubmission(), this.isFormValid());
      }, 0);
    }
  };


  render() {
    return (
      <React.Fragment>
        {this.props.data && (
          <div id='formio'>
            <div className='container DataEntryForm'>
              <Form
                formId={this.props.formId}
                ref={(form) => (this.form = form)}
                data={this.props.data}
                onRender={this.onFormRender}
                onChange={(f, isValid) => this.onChange(f, isValid)}
                setFormErrors={this.props.setFormErrors}
              />
            </div>
          </div>
        )}
        {!this.props.data && <div>Report Draft Data not found!</div>}
        {this.state.sidebarElement &&
          ReactDOM.createPortal(
            this.props.injectToSidebar,
            this.state.sidebarElement
          )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    serviceURL: reduxState.Application.backendURL,
    formIOUrl: reduxState.Application.formIOUrl,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(DataEntryForm);
